import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { openLoading } from "store/reducers/tools";

export default function Logout() {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    openLoading(true);
    setTimeout(() => {
      dispatch({ type: "RESET_AUTH" });
      openLoading(false);
      history.push("/");
    }, 3000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div></div>;
}
